<template lang="pug">
#operatePanel.comAll(v-dragDiv,v-show="!actionData.isMini")
  .title.moveDragDiv
    span {{actionData.cnName}}
    i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
    i.el-icon-close(title='关闭' @click='closeAdd')
  .content
    el-form(ref="form" size="mini" label-width="40px")
      el-form-item(label="楼层")
        el-select(v-model='curLevel'  placeholder='请选择' @change='levelChange')
          el-option(v-for='item in levels' :key='item.id' :label='item.name' :value='item.id')
      el-form-item(label="房间" )
        el-tree(:data="treeData" class="roomTree" :props="defaultProps" @node-click="handleNodeClick" id="roomTree")
      el-form-item
        el-button(type="success" @click="selectByRect" size="small") 框选房间
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data () {
    return {
      curLevel: '',
      treeData: [],
      defaultProps: {
        label: "label"
      }
    };
  },
  computed: {
    levels() {
      return mongeApiMlib.getLevels();
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init() {
      this.curLevel = this.levels[0].id;
      this.treeData = mongeApiMlib.spaceView(this.curLevel);
    },
    levelChange() {
      this.treeData = mongeApiMlib.spaceView(this.curLevel);
    },
    handleNodeClick(node) {
      mongeApiMlib.selectOnlyOneById(node.revitId);
    },
    selectByRect() {
      mongeApiMlib.selectByRect();
    },
    miniCom() {
      this.$emit("closeCom", 'areaPlane', true);
    },
    closeAdd() {
      this.$emit("closeCom", 'areaPlane', false);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss"></style>
<style lang="scss" scoped>
#operatePanel{
  position: fixed;
  top: 65px;
  left: 151px;
  width: 300px;
  height: 550px;
  .content{
    width: 100%;
    height: calc(100% - 40px);
    padding: 10px 10px 10px 15px;
    overflow: hidden;
    .el-select,.el-button{
      width: 100%;
    }
    .roomTree{
      max-height: 400px;
      overflow-y: auto;
    }
  }
}
</style>
